// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 7594 ? "about" : chunkId) + ".Ru2Pq6nUCE1788342753105.js";
};